import { render, staticRenderFns } from "./ProductPickerPanel.vue?vue&type=template&id=31d7afc3&"
import script from "./ProductPickerPanel.vue?vue&type=script&lang=js&"
export * from "./ProductPickerPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProductPickerPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports